import * as actionTypes from '../actions/actionTypes';


export default function newManualCase(state = {}, action) {
    switch(action.type){
      case actionTypes.NEW_MANUAL_CASE:
      let newState = {...state};
      newState.newCase = action.newCase;
      return newState.newCase;
      case actionTypes.DESTROY_SESSION:
      return {};


      default: return state;

    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/reducers/newManualCase.js